var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "mastercard",
    xmlns: "http://www.w3.org/2000/svg",
    width: 99,
    height: 43,
    viewBox: "0 0 99 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161406",
    "data-name": "Rectangle 161406",
    width: 99,
    height: 43,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(23.097 4.832)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161255",
    "data-name": "Rectangle 161255",
    width: 53.103,
    height: 31.415,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_173801",
    "data-name": "Group 173801",
    transform: "translate(6.242 3.164)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_161256",
    "data-name": "Rectangle 161256",
    width: 10.976,
    height: 19.723,
    transform: "translate(14.807 2.682)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38069",
    "data-name": "Path 38069",
    d: "M353.215,282.543a12.522,12.522,0,0,1,4.791-9.862,12.543,12.543,0,1,0,0,19.723,12.522,12.522,0,0,1-4.791-9.862Z",
    transform: "translate(-337.711 -270)",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38070",
    "data-name": "Path 38070",
    d: "M416.253,282.543a12.543,12.543,0,0,1-20.294,9.862,12.545,12.545,0,0,0,0-19.723,12.543,12.543,0,0,1,20.294,9.862Z",
    transform: "translate(-375.663 -270)",
    fill: "#f79e1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38071",
    "data-name": "Path 38071",
    d: "M450.3,327.4v-.4h.163v-.082h-.415v.082h.163v.4Zm.805,0v-.487h-.127l-.146.335-.146-.335h-.127v.487h.09v-.367l.137.317h.093l.137-.317v.368Z",
    transform: "translate(-410.905 -307.081)",
    fill: "#f79e1b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.a4b7847115e8d9def76ad2522ae0695f.svg";
export { ForwardRef as ReactComponent };